<template>
  <div class="ele-body">
    <el-card shadow="never">
      <!-- 搜索表单 -->
      <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="角色名称:">
              <el-input name="roleName" v-model.trim="table.where.roleName" placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <el-form-item label="备注:">
              <el-input v-model.trim="table.where.remark" placeholder="请输入" clearable />
            </el-form-item>
          </el-col>
          <el-col :md="6" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询 </el-button>
              <el-button @click="showEdit = true" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加</el-button>
              <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon">删除</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <!-- 数据表格 -->
      <ele-data-table ref="table" :config="table" :choose.sync="choose" highlight-current-row>
        <template #default="{ index }">
          <el-table-column type="selection" width="45" align="center" fixed="left" />
          <el-table-column type="index" :index="index" width="45" align="center" fixed="left" show-overflow-tooltip />
          <el-table-column prop="roleName" label="角色名称" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="remark" label="备注" sortable="custom" show-overflow-tooltip min-width="110" />
          <el-table-column prop="createTime" label="创建时间" sortable="custom" show-overflow-tooltip min-width="110">
            <template #default="{ row }">{{ row.createTime | toDateString }}</template>
          </el-table-column>
          <el-table-column label="操作" width="350px" align="center" :resizable="false">
            <template #default="{ row }">
              <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false" :disabled="row.administrator == '1'">修改</el-link>
              <el-link @click="auth(row)" icon="el-icon-finished" type="primary" :underline="false" :disabled="row.administrator == '1'"
                >分配权限</el-link
              >
              <el-popconfirm title="确定要删除此角色吗？" @onConfirm="remove(row)" class="ele-action">
                <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false" :disabled="row.administrator == '1'">删除</el-link>
              </el-popconfirm>
              <el-link @click="importAuth(row)" icon="el-icon-upload" type="primary" :underline="false" :disabled="row.administrator == '1'"
                >批量分配权限</el-link
              >
            </template>
          </el-table-column>
        </template>
      </ele-data-table>
    </el-card>
    <!-- 编辑弹窗 -->
    <el-dialog
      :title="editForm.id ? '修改角色' : '添加角色'"
      :visible.sync="showEdit"
      width="400px"
      @closed="editForm = {}"
      :destroy-on-close="true"
      :lock-scroll="false"
    >
      <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="82px">
        <el-form-item label="角色名称:" prop="roleName">
          <el-input v-model="editForm.roleName" placeholder="请输入角色名称" clearable />
        </el-form-item>
        <el-form-item label="序号:" prop="roleSort">
          <el-input v-model="editForm.roleSort" placeholder="请输入序号" clearable />
        </el-form-item>
        <el-form-item label="备注:">
          <el-input v-model="editForm.remark" placeholder="请输入备注" :rows="4" type="textarea" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" @click="save(editForm.id)">保存</el-button>
      </div>
    </el-dialog>
    <!-- 权限分配弹窗 -->
    <el-dialog
      :destroy-on-close="true"
      :lock-scroll="false"
      :visible.sync="showMenu"
      title="分配权限"
      width="900px"
      class="menu-dialog"
      @closed="editForm = {}"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <div class="menu-section">
            <div class="section-header">
              <i class="el-icon-monitor"></i>
              <span>PC 端菜单</span>
              <el-checkbox v-model="checkedPCAll" @change="PcCheckAll" style="margin-left: 10px">全选</el-checkbox>
            </div>
            <div class="section-content">
              <el-scrollbar style="height: 450px">
                <el-tree
                  ref="pcMenuTree"
                  :data="pcMenuData"
                  :default-checked-keys="pcChecked"
                  :default-expanded-keys="dataIdArrPc"
                  node-key="id"
                  show-checkbox
                  :props="{ label: 'menuName' }"
                  @check="pcmenuNum"
                />
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ data.menuName }}</span>
                  <span style="color: #cccccc">{{ data.remark != '' ? '（' + data.remark + '）' : '' }}</span>
                </span>
              </el-scrollbar>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="menu-section">
            <div class="section-header">
              <i class="el-icon-mobile-phone"></i>
              <span>微信端菜单</span>
              <el-checkbox v-model="checkedWXAll" @change="WxCheckAll" style="margin-left: 10px">全选</el-checkbox>
            </div>
            <div class="section-content">
              <el-scrollbar style="height: 450px">
                <el-tree
                  ref="phoneMenuTree"
                  :data="phoneMenuData"
                  :default-checked-keys="phoneChecked"
                  :default-expanded-keys="dataIdArrWx"
                  node-key="id"
                  show-checkbox
                  :props="{ label: 'menuName' }"
                  @check="wxmenuNum"
                />
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ data.menuName }}</span>
                  <span style="color: #cccccc">{{ data.remark != '' ? '（' + data.remark + '）' : '' }}</span>
                </span>
              </el-scrollbar>
            </div>
          </div>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showMenu = false">
          <i class="el-icon-close"></i>
          取消
        </el-button>
        <el-button type="primary" @click="saveAuth">
          <i class="el-icon-check"></i>
          保存
        </el-button>
      </div>
    </el-dialog>
    <!--批量分配权限弹窗-->
    <el-dialog
      title="请选择相应的教师"
      :visible.sync="showImportAuth"
      width="440px"
      :destroy-on-close="true"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <el-scrollbar style="height: 50vh" wrapStyle="overflow-x: hidden;">
        <el-tree
          ref="teacherTree"
          :data="teacherList"
          :props="{ label: 'name' }"
          node-key="key"
          show-checkbox
          :default-expanded-keys="teacherListNode"
          :default-checked-keys="checkedList"
          @check-change="setTeacherChecked"
        />
      </el-scrollbar>
      <div slot="footer">
        <el-button @click="showImportAuth = false">取消</el-button>
        <el-button type="primary" @click="saveTeacherAuth">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  // import Qs from "qs";
  import {
    addSchoolRole,
    roleBatchTeacherList,
    getAllDepartTeachers,
    updateSchoolRoleMenuList,
    updateSchoolRole,
    delSchoolRole,
    batchDelSchoolRole,
    getSchoolRoleMenuList,
    getAllDepartTeachersRole,
  } from '../../../config/api.js'; //添加角色接口
  export default {
    name: 'SysRole',
    data() {
      return {
        table: {
          // 表格配置
          url: '/school/schoolRole/getSchoolRoleListByPage',
          method: 'GET',
          where: {},
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [], // 表格选中数据
        showEdit: false, // 是否显示表单弹窗
        editForm: {}, // 表单数据
        editRules: {
          // 表单验证规则
          roleName: [{ required: true, message: '请输入角色名称', trigger: 'blur' }],
          roleSort: [{ required: true, message: '请输入序号', trigger: 'blur' }],
        },
        showMenu: false, // 显示权限分配弹窗
        pcMenuData: [], // 权限分配数据
        phoneMenuData: [], //微信权限
        ids: [],
        checkedPCAll: false,
        checkedWXAll: false,
        pcMenuNum: '', //pc菜单数量
        wxMenuNum: '', //微信端菜单数量
        authTemplate: 'https://hdsys.oss-cn-beijing.aliyuncs.com/hdjxt/template/1630632264208/角色教师信息.xlsx',
        showImportAuth: false,
        uploadLoading: false, // 导入加载状态
        fileParam: {
          roleId: '',
          teacherIds: [],
        },
        dataIdArrPc: [],
        dataIdArrWx: [],
        teacherList: [],
        teacherListNode: [0],
        checkedTeacherList: [],
        checkedList: [],
      };
    },
    computed: {
      /* 权限树选中数据 */
      pcChecked() {
        let pcChecked = [];
        this.$util.eachTreeData(this.pcMenuData, (d) => {
          if (d.checked && (!d.children || !d.children.length)) pcChecked.push(d.id);
        });
        return pcChecked;
      },
      phoneChecked() {
        let phoneChecked = [];
        this.$util.eachTreeData(this.phoneMenuData, (d) => {
          if (d.checked && (!d.children || !d.children.length)) phoneChecked.push(d.id);
        });
        return phoneChecked;
      },
    },

    methods: {
      /* 显示编辑 */
      edit(row) {
        this.editForm = Object.assign({}, row);
        this.showEdit = true;
      },
      /* 保存编辑 */
      save(roleID) {
        this.$refs['editForm'].validate((valid) => {
          if (valid) {
            const loading = this.$loading({ lock: true });
            let formData = new FormData();
            for (let key in this.editForm) {
              if (this.editForm[key] !== null && this.editForm[key] !== undefined) {
                formData.append(key, this.editForm[key]);
              }
            }
            if (roleID == undefined) {
              // 添加角色
              addSchoolRole(formData).then((res) => {
                loading.close();
                // console.log(res);
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            } else {
              formData.append('id', roleID); //备注
              // 编辑保存角色
              updateSchoolRole(formData).then((res) => {
                loading.close();
                if (res.data.resCode == 200) {
                  this.showEdit = false;
                  this.$message({ type: 'success', message: res.data.resMsg });
                  this.$refs.table.reload();
                } else {
                  this.$message.error(res.data.resMsg);
                }
              });
            }
          } else {
            return false;
          }
        });
      },
      /* 删除 */
      remove(row) {
        if (!row) {
          //批量删除
          if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
          for (let i = 0; i < this.choose.length; i++) {
            if (this.choose[i].administrator == '1') {
              return this.$message.error('不能删除学生管理员');
            }
          }
          this.ids = this.choose.map((d) => d.id);
          this.$confirm('确定要删除选中的角色吗?', '提示', { type: 'warning' })
            .then(() => {
              const loading = this.$loading({ lock: true });
              let ids = new FormData();
              ids.append('ids', this.ids);
              batchDelSchoolRole(ids)
                .then((res) => {
                  // console.log(res);
                  loading.close();
                  if (res.data.resCode == 200) {
                    this.$message({ type: 'success', message: res.data.resMsg });
                    this.$refs.table.reload();
                  } else {
                    this.$message.error(res.data.resMsg);
                  }
                })
                .catch((e) => {
                  loading.close();
                  this.$message.error(e.message);
                });
            })
            .catch(() => 0);
        } else {
          if (row.administrator == 1) return this.$message.error('不能删除学校管理员');
          const loading = this.$loading({ lock: true });
          let id = new FormData();
          id.append('id', row.id);
          delSchoolRole(id)
            .then((res) => {
              // console.log(res);
              loading.close();
              if (res.data.resCode == 200) {
                this.$message({ type: 'success', message: res.data.resMsg });
                this.$refs.table.reload();
              } else {
                this.$message.error(res.data.resMsg);
              }
            })
            .catch((e) => {
              loading.close();
              this.$message.error(e.message);
            });
        }
      },
      /* 显示分配权限弹窗 */
      auth(row) {
        this.editForm = Object.assign({}, row);
        this.pcMenuData = [];
        this.phoneMenuData = [];
        const loading = this.$loading({ background: 'transparent' });
        let params = { id: row.id };
        getSchoolRoleMenuList(params).then((res) => {
          loading.close();
          this.showMenu = true;
          if (res.data.resCode == 200) {
            // var newPCdata = res.data.data[0].pc.filter(d => {
            //   if (d.visible == 1){
            //     return d
            //   }
            // })
            // var newWxdata = res.data.data[1].phone.filter(d => {
            //   if (d.menuType != 'F'){
            //     return d
            //   }
            // })
            this.pcMenuNum = res.data.data[0].pc.length;
            this.wxMenuNum = res.data.data[1].phone.length;
            let pcNum = 0,
              WxNum = 0;
            res.data.data[0].pc.forEach((d) => {
              if (d.checked) pcNum++;
            }); //判断pc端菜端选中个数
            res.data.data[1].phone.forEach((d) => {
              if (d.checked) WxNum++;
            }); //判断微信端菜端选中个数
            if (pcNum == res.data.data[0].pc.length) {
              this.checkedPCAll = true;
            } else {
              this.checkedPCAll = false;
            }
            if (WxNum == res.data.data[1].phone.length) {
              this.checkedWXAll = true;
            } else {
              this.checkedWXAll = false;
            }

            this.pcMenuData = this.$util.toTreeData(res.data.data[0].pc, 'id', 'parentId');
            this.dataIdArrPc = this.$util.getTreeFloor(this.pcMenuData, 1, this.dataIdArrPc, 'id');
            this.phoneMenuData = this.$util.toTreeData(res.data.data[1].phone, 'id', 'parentId');
            this.dataIdArrWx = this.$util.getTreeFloor(this.phoneMenuData, 1, this.dataIdArrWx, 'id');
            // this.pcMenuData = this.$util.toTreeData( res.data.data[0].pc, "id", "parentId");
            // this.phoneMenuData = this.$util.toTreeData( res.data.data[1].phone, "id", "parentId");
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      /* 保存权限分配 */
      saveAuth() {
        const loading = this.$loading({ lock: true });
        let pcids = this.$refs.pcMenuTree.getCheckedKeys().concat(this.$refs.pcMenuTree.getHalfCheckedKeys());
        let wxIds = this.$refs.phoneMenuTree.getCheckedKeys().concat(this.$refs.phoneMenuTree.getHalfCheckedKeys());
        let ids = pcids.concat(wxIds);
        let data = new FormData();
        data.append('id', this.editForm.id);
        data.append('ids', ids);
        updateSchoolRoleMenuList(data).then((res) => {
          loading.close();
          if (res.data.resCode == 200) {
            this.showMenu = false;
            this.$message({ type: 'success', message: res.data.resMsg });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 全选框PC变化时
      PcCheckAll(checked) {
        if (checked === true) {
          this.$refs.pcMenuTree.setCheckedNodes(this.pcMenuData);
        } else {
          this.$refs.pcMenuTree.setCheckedKeys([]);
        }
      },
      // 全选框WX变化时
      WxCheckAll(checked) {
        if (checked === true) {
          this.$refs.phoneMenuTree.setCheckedNodes(this.phoneMenuData);
        } else {
          this.$refs.phoneMenuTree.setCheckedKeys([]);
        }
      },
      pcmenuNum(val, res) {
        // console.log(res);
        if (res.checkedKeys.length == this.pcMenuNum) {
          this.checkedPCAll = true;
        } else {
          this.checkedPCAll = false;
        }
      },
      wxmenuNum(val, res) {
        if (res.checkedKeys.length == this.wxMenuNum) {
          this.checkedWXAll = true;
        } else {
          this.checkedWXAll = false;
        }
      },
      // 打开批量分配权限选择教师弹窗
      importAuth(row) {
        this.fileParam.roleId = row.id;
        this.fileParam.teacherIds = [];
        let data = {
          roleId: row.id,
        };
        getAllDepartTeachersRole(data).then((res) => {
          if (res.data.resCode == 200) {
            this.checkedTeacherList = res.data.data.choiceId;
            getAllDepartTeachers(data).then((res) => {
              if (res.data.resCode == 200) {
                this.teacherList = this.$util.toTreeData(res.data.data, 'id', 'parentId');
                this.deleteChildren(this.teacherList);
                // this.getRoleTreeRootNode(this.teacherList[0].id)
                this.addKeyToList(this.teacherList);
                this.showImportAuth = true;
              } else {
                this.$message.error(res.data.resMsg);
              }
            });
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      // 给树的每一个节点 添加一个key（唯一值），并算出默认选中的节点key数组
      addKeyToList(data) {
        let key = 0;
        this.$util.eachTreeData(data, (d) => {
          d.key = key++;
        });
        this.checkedList = this.contrastList(data);
      },
      contrastList(data) {
        let checkedList = [];
        this.$util.eachTreeData(data, (d) => {
          this.checkedTeacherList.forEach((item) => {
            if (item == d.id) {
              checkedList.push(d.key);
            }
          });
        });
        return checkedList;
      },
      // 获取树形结构默认展开节点
      getRoleTreeRootNode(provincialCenterId) {
        this.teacherListNode.push(provincialCenterId);
      },
      // 循环数组 children为空时删除 且部系年级下无children时禁用
      deleteChildren(data) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].children) {
            if (data[i].children.length) {
              this.deleteChildren(data[i].children);
            } else {
              data[i].disabled = true;
              if (data[i].type !== 2) {
                delete data[i].children;
              }
            }
          }
        }
        return data;
      },
      // 保存批量分配权限
      saveTeacherAuth() {
        let teacherIds = this.$refs.teacherTree.getCheckedNodes();
        this.getNodeteacherIds(teacherIds);
        let formData = new FormData();
        for (let key in this.fileParam) {
          if (this.fileParam[key] !== null && this.fileParam[key] !== undefined) {
            formData.append(key, this.fileParam[key]);
          }
        }
        roleBatchTeacherList(formData).then((res) => {
          if (res.data.resCode == 200) {
            this.$message({ type: 'success', message: res.data.resMsg });
            this.$refs.table.reload();
            this.showImportAuth = false;
          } else {
            this.$message.error(res.data.resMsg);
          }
        });
      },
      //循环数组获取教师id
      getNodeteacherIds(data) {
        data.forEach((item) => {
          if (item.type == 2) {
            this.fileParam.teacherIds.push(item.id);
          }
        });
        this.fileParam.teacherIds = [...new Set(this.fileParam.teacherIds)];
      },
      // 点击节点，判断该节点id是否有重复的，如果有相同id执行相同的操作
      setTeacherChecked(data, isChecked) {
        this.$util.eachTreeData(this.teacherList, (item) => {
          if (data.id === item.id) {
            this.$refs.teacherTree.setChecked(item.key, isChecked, false);
          }
        });
      },
      // 批量导入权限成功
      // uploadInfoSuccess(res){
      //   this.uploadLoading = false;
      //   if (res.resCode == "200") {
      //     this.showImportAuth = false;
      //     this.$message({type:'success', message: res.resMsg});
      //   } else if (res.resCode == "5001") {
      //     const url = res.resMsg;
      //     this.$confirm('是否下载本次导入失败的记录', '温馨提示', {
      //       confirmButtonText: '确定',
      //       cancelButtonText: '取消',
      //       type: 'warning',
      //     }).then(() => {
      //       window.open(url);
      //       this.showImportAuth = false;
      //     }).catch(() => {
      //       this.$message({
      //         type: 'info',
      //         message: '下载失败'
      //       });
      //       this.showImportAuth = false;
      //     })
      //   } else {
      //     this.$message.error(res.resMsg);
      //   }
      // }
    },
  };
</script>

<style lang="scss" scoped>
  .ele-block {
    display: flex !important;
    flex-flow: column !important;
    align-items: center !important;
  }
  .menu-dialog {
    ::v-deep .el-dialog__header {
      padding: 20px 24px;
      border-bottom: 1px solid #ebeef5;
      margin-right: 0;

      .el-dialog__title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
      }
    }

    ::v-deep .el-dialog__body {
      padding: 24px;
      background-color: #f5f7fa;
    }

    ::v-deep .el-dialog__footer {
      padding: 15px 24px;
      border-top: 1px solid #ebeef5;
    }
  }

  .menu-section {
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);

    .section-header {
      display: flex;
      align-items: center;
      gap: 10px;
      padding: 16px 20px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #ffffff;

      i {
        font-size: 20px;
      }

      span {
        font-size: 16px;
        font-weight: 600;
      }
    }

    .section-content {
      padding: 16px;
      background-color: #fafafa;

      ::v-deep .el-tree {
        background-color: transparent;

        .el-tree-node__content {
          height: 36px;
          padding: 0 8px;
          border-radius: 4px;
          margin-bottom: 4px;

          &:hover {
            background-color: #f0f9ff;
          }

          &.is-current {
            background-color: #ecf5ff;
            color: #409eff;
          }
        }

        .el-checkbox__input {
          .el-checkbox__inner {
            border-color: #dcdfe6;
            border-radius: 3px;
          }

          &.is-checked {
            .el-checkbox__inner {
              background-color: #409eff;
              border-color: #409eff;
            }
          }
        }
      }
    }
  }

  .dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .el-button {
      min-width: 100px;
      height: 40px;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;

      i {
        margin-right: 6px;
        font-size: 16px;
      }

      &:not(:last-child) {
        margin-right: 0;
      }
    }
  }
</style>
